import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function TirePressureInstruction() {
  const {t} = useInferableTranslation();
  return (
    <div className="section_container">
      <div className="section_container_header">
        <h3 className="title_xsmall_b">{t('T30006')}</h3>
      </div>
      <p className="tire_pressure_desc">{t('T30007')}</p>
      <div className="divider"></div>
      <div className="section_container_header">
        <h3 className="title_xsmall_b">{t('T30008')}</h3>
      </div>
      <p className="tire_pressure_desc">{t('T30009')}</p>
    </div>
  );
}

export default TirePressureInstruction;
